import { useEffect, useRef } from 'react';

import { useAnalytics } from '../analytics/use-analytics';

export function SkippedAction() {
	const { sendAnalyticsEvent } = useAnalytics();
	const hasSent = useRef(false);

	useEffect(() => {
		if (hasSent.current) {
			return;
		}

		sendAnalyticsEvent({
			eventType: 'operational',
			actionSubject: 'actionsAndContent',
			actionSubjectId: 'editionAwareness',
			action: 'skipped',
		});

		hasSent.current = true;
	}, [sendAnalyticsEvent]);

	return null;
}
